export default __webpack_public_path__ + "static/media/banner2.af0d26db.svg";